import axios from 'axios'

// const API_URL = 'http://api.ginfo.inovess.com.br'
const getApiUrl = () => {
  const currentHost = window.location.hostname

  if (currentHost === 'localhost') { return 'https://api.ginfo.io' }
  // if (currentHost === 'localhost') { return 'http://api.ginfo.inovess.com.br:8000' }
  // if (currentHost === 'localhost') { return 'http://api.ginfo.inovess.com.br' }

  if (currentHost.includes('teste.terminaldaoficina.inovess.com.br')) { return 'http://sandbox.api.ginfo.inovess.com.br' }
  if (currentHost.includes('terminaldaoficina.inovess.com.br')) { return 'https://api.ginfo.inovess.com.br' }
  if (currentHost.includes('terminaldaoficina.ginfo.app.br')) { return 'https://api.ginfo.app.br/' }
  if (currentHost.includes('terminaldaoficina.ginfoapp.com.br')) { return 'https://api.ginfo.inovess.com.br' }
  if (currentHost.includes('terminaldaoficina.ginfo.io')) { return 'https://api.ginfo.io' }
}

// const API_URL = 'http://api.ginfo.inovess.com.br'
const getApiKey = (empresaLogin) => {
  const apiKeys = {
    localhost: '646C19373AC9E27E972C8E3BDF6554C4C10D23006C1ABEC3407CBFF80C4AB71F',
    // 'LOG20': '646C19373AC9E27E972C8E3BDF6554C4C10D23006C1ABEC3407CBFF80C4AB71F',
    'LOG20': 'F2E8591802769C058B9C0B00AED85E09FFC404F8B1901A402E043157EEAE47B6',
    'AMBEV': 'F2E8591802769C058B9C0B00AED85E09FFC404F8B1901A402E043157EEAE47B6',
    'GRUPOT2P': 'F2E8591802769C058B9C0B00AED85E09FFC404F8B1901A402E043157EEAE47B6',
    'TSV': '178B9DAE9EE6BD5AA88D77470E071001189D8844A9204EE671085D9AE22EB923',
    'MADEPAR': 'C9A958B0998304517CD8CF15F23C6A10F5A35EE729B5C7992CCAFFB36440FF87',
    'log20.terminaldaoficina.inovess.com.br': 'F2E8591802769C058B9C0B00AED85E09FFC404F8B1901A402E043157EEAE47B6',
    // 'nelog.terminaldaoficina.inovess.com.br': '178B9DAE9EE6BD5AA88D77470E071001189D8844A9204EE671085D9AE22EB923',
    'OP.DEDICADAS': '178B9DAE9EE6BD5AA88D77470E071001189D8844A9204EE671085D9AE22EB920',
    'I9_DEMONSTRACAO': '178B9DAE9EE6BD5AA88D77470E071001189D8844A9204EE671085D9AE22EB929',
    'NEXWAY': 'F2E8591802769C058B9C0B00AED85E09FFC404F8B1901A402E043157EEAE47B6'
    // 'carrefour.terminaldaoficina.inovess.com.br': '178B9DAE9EE6BD5AA88D77470E071001189D8844A9204EE671085D9AE22EB920'
  }
  
  let currentHost = empresaLogin                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
  let currentHostLink = window.location.hostname       
  
  if(currentHostLink == 'log20.terminaldaoficina.inovess.com.br'){
    currentHost = currentHostLink
  } else if (currentHostLink == 'localhost'){
    currentHost = currentHostLink
  }

  if (apiKeys[currentHost]) {
    return apiKeys[currentHost]
  }

  return null
}


const getLocalStorageToken = () => {
  if (!localStorage.getItem('filial')) {
    return null
  }

  const localStorageFilial = JSON.parse(localStorage.getItem('filial'))
  if (!localStorageFilial.token) {
    return null
  }

  return localStorageFilial.token
}

var unauthorizedCallback = null
const setUnauthorizedCallback = (callback) => {
  unauthorizedCallback = callback
}

const empresaLogin = () => {
  if(localStorage.empresa != undefined){
    var empresa = JSON.parse(localStorage.empresa)
  }

  return empresa
}

const empresaHash = () => {
  if(localStorage.empresa != undefined){
    try {
      var empresa = JSON.parse(localStorage.empresa)   
    
      return empresa.key

    } catch (error) {
      throw Error(error)
    }
  }

}

const client = axios.create({
  baseURL: `${getApiUrl()}`,
  headers: {
    // idioma: 'en',
    Accept: 'application/json',
    ApiKey: `${empresaHash()}`,
    'Content-Type': 'application/json;charset=UTF-8',
  }
})


client.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response.status === 401) {
    if (unauthorizedCallback) {
      unauthorizedCallback()
    }
  }
  return Promise.reject(error)
})

client.interceptors.request.use((config) => {
  const idiomaJSON = localStorage.getItem('lang') || 'pt'
  const idiomaParse = JSON.parse(idiomaJSON)
  const idioma = idiomaParse.lang

  // GET → envia como query param
  if (config.method === 'get') {
    config.params = {
      ...(config.params || {}),
      idioma
    }
  }

  // POST / PUT / PATCH → envia no body
  if (['post', 'put', 'patch'].includes(config.method)) {
    // ✅ SE FOR FormData
    if (config.data instanceof FormData) {
      config.data.append('idioma', idioma)
    } 
    // ✅ SE FOR JSON NORMAL
      else {
      config.data = {
        ...(config.data || {}),
        idioma
      }
    }
  }

  return config
})

const setToken = (client) => {
  client.defaults.headers.common.Token = getLocalStorageToken()

  return client
}

export default client

export { setToken, setUnauthorizedCallback, empresaLogin }
